import { useEffect } from 'react'
import { router } from '@inertiajs/react'

// An installed PWA is never reloaded the way a browser tab is: iOS keeps the page alive in the
// background for days, so reopening the app would otherwise show the album exactly as it looked
// last time, and an app left open on the counter never sees what anyone else posted.
//
// So: refetch when the app comes back to the foreground, and poll gently while it is open.
const POLL_MS = 60_000

// Inertia runs one visit at a time and cancels the previous one, which means a poll firing
// mid-upload would abort the upload. Track whether a visit is in flight and stay out of the way.
let visitInFlight = false
router.on('start', () => {
  visitInFlight = true
})
router.on('finish', () => {
  visitInFlight = false
})

export default function useLiveRefresh(only = []) {
  useEffect(() => {
    function refresh() {
      if (visitInFlight) return
      if (document.visibilityState !== 'visible') return

      // A partial reload asks the controller for these props alone, so polling costs one
      // query rather than a full page render.
      router.reload({ only })
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'visible') refresh()
    }

    document.addEventListener('visibilitychange', onVisibilityChange)
    const timer = setInterval(refresh, POLL_MS)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
      clearInterval(timer)
    }
    // `only` is a literal at every call site; joining keeps the effect from re-running each render.
  }, [only.join(',')])
}
